import { useEffect, useState, useRef } from "react";

export const useTimedCounter = (args: {
  onComplete: () => void;
  start: number;
  end: number;
  /**
   * Value added to the current count-down state.
   *
   * To count downwards (e.g., 10 -> 9 -> 8 ...), use a negative number (e.g., -1)
   */
  by: number;
  /**
   * The length of the timeout before adding the {@link args.by} value
   */
  interval: number;
}) => {
  const [count, setCount] = useState(args.start);

  const onCompleteRef = useRef(args.onComplete);
  onCompleteRef.current = args.onComplete;

  const { by, end, interval } = args;
  useEffect(() => {
    const countInterval = setInterval(() => {
      setCount((prevCount) => {
        const nextCount = prevCount + by;

        let hasReachedEnd = nextCount <= end;
        if (by > 0) {
          hasReachedEnd = nextCount >= end;
        }

        if (hasReachedEnd) {
          clearInterval(countInterval);
          onCompleteRef.current();
          return end; // prevents overshooting
        }

        return nextCount;
      });
    }, interval);

    return () => clearInterval(countInterval);
  }, [by, end, interval]);

  return { count };
};
